// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_jk_","cls2":"Comments-cls2__WV Comments-cls1_jk_"};